import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
};

export const categoriesSlice = createSlice({
  name: "catogories",
  initialState,
  reducers: {
    updateCategoriesSlice: (state, action) => {
      state.categories = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateCategoriesSlice } = categoriesSlice.actions;
export default categoriesSlice.reducer;
